import { CircularProgress } from "@mui/material";
import { colors } from "../utils/constants";
import OtpInput from "./OtpInput/OtpInput";
import Button from "./Button/Button";
import { useState } from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const OtpComponent = ({
  otpInput,
  value,
  setOtpInput,
  showError,
  loading,
  isMobile,
  submit,
  resend,
  onBack,
}: {
  otpInput: string;
  value: string;
  setOtpInput: (val: string) => void;
  showError?: boolean;
  loading?: boolean;
  isMobile?: boolean;
  submit: () => void;
  resend?: () => void;
  onBack?: () => void;
}) => {
  const [refresh, setRefresh] = useState(false);

  return (
    <div className="text-center">
      <h3 className="text-[32px] font-bold text-navy-blue mb-8 text-center">Verification Code</h3>
      {isMobile ? (
        <>
          <h3 className="text-base mb-2">We need to validate your phone number.</h3>
          <p className="text-base mb-5">
            We have sent a 6 digit code to your phone number: +1-<b>{value}</b>.
          </p>
        </>
      ) : (
        <>
          <p className="text-base mb-7">
            We have sent a 6 digit code to your email:
            <br /> <b>{value}</b>.
          </p>
          <p className="text-base mb-10">Please check your email and enter the code provided below.</p>
        </>
      )}
      <OtpInput length={6} onChange={e => setOtpInput(e)} refresh={refresh} isChangeField={value} />
      {showError ? <p style={{ color: colors.Red }}>{"Code entered is invalid. Please click Try again to request a new code."}</p> : null}
      {onBack && (
        <div className="cursor-pointer text-docsigna-purple-dark font-medium mt-2 w-fit" onClick={onBack}>
          <KeyboardBackspaceIcon /> Back
        </div>
      )}
      <div className="tab-content pt-8 pb-7">
        {loading ? (
          <CircularProgress size="1.5rem" sx={{ color: colors.Orange }} />
        ) : (
          <Button text="Continue" width="full" disabled={otpInput.length !== 6} onClick={() => submit()} variant={"Primary"} className="h-[50px]" />
        )}
      </div>
      {resend ? (
        <p className="text-base font-medium">
          Didn’t receive a code?{" "}
          <span
            className="text-base text-docsigna-purple-dark cursor-pointer"
            onClick={async () => {
              setRefresh(false);
              await resend();
              setRefresh(true);
            }}
          >
            Resend Code
          </span>{" "}
        </p>
      ) : null}
    </div>
  );
};

export default OtpComponent;
